import React from 'react'
import MaterialSymbol from '../material-symbol'

const MenuBook = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="menu_book" {...props} />
))

MenuBook.displayName = 'MenuBook'

export default MenuBook
